import ReducerRegistry from '../../../react/features/base/redux/ReducerRegistry';
import { assign } from '../../../react/features/base/redux/functions';

import {
    WIS_EVENTS,
    WIS_RESPONSE_RECEIVED,
    WIS_RPC_COMMANDS
} from './constants';

const DEFAULT_STATE = {
    isConnected: false,
    isAuthorized: false,
    version: {}
};

ReducerRegistry.register('wildix/features/wiservice', (state = DEFAULT_STATE, action) => {

    switch (action.type) {
    case WIS_RESPONSE_RECEIVED: {
        const msgData = action.message?.msgdata || {};

        switch (msgData.type) {
        case WIS_RPC_COMMANDS.AUTHORIZE: {
            return assign(state, {
                isConnected: msgData.status === 'authorized',
                isAuthorized: msgData.status === 'authorized'
            });
        }
        case WIS_RPC_COMMANDS.VERSION: {
            const { headset, screensharing, wiservice } = msgData;

            return assign(state, {
                version: {
                    headset,
                    screensharing,
                    wiservice
                }
            });
        }
        }
        break;
    }
    case WIS_EVENTS.CONNECT: {
        const { payload } = action;

        return assign(state, {
            isConnected: payload.isConnected
        });
    }
    }

    return state;
});
